export default function appendfragment(
    exitLink,
    ct = '_',
    ctaLocation = '_',
    listId = '_',
    listType = '_',
    listVersion = '_',
    listPosition = '_',
    listLocation = '_'
) {
    if (!exitLink) {
        return '';
    }
    exitLink = exitLink.toString();

    let params = new URLSearchParams();

    let query = {
        listid: listId,
        listtype: listType,
        listlocation: listLocation,
        listversion: listVersion,
        list_position: listPosition,
        ct: ct,
        ctalocation: ctaLocation,
    };

    for (const key in query) {
        params.append(key, query[key]);
    }

    return `${exitLink}#${params.toString()}`;
}
